import download from 'downloadjs';
import { SuSyApi } from '../api/susyApi';

export const downloadFile = async (fileUrl: string, fileName: string) => {
    const result = await SuSyApi.get(fileUrl, {
        responseType: 'blob',
    });

    return download(result.data, fileName);
};
